// routes for shortcut
export default {
  path: '/shortcut',
  name: 'shortcut',
  component: () => import('@/modules/shortcut/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        page_slug: 'shortcut',
      },
    ],
    title: 'eRank — Shortcut',
    requiresAuth: true,
  },
};
